export default __webpack_public_path__ + "static/media/markAsUnread.7e95ad2d.svg";